import { type FC } from 'react';
import FilterOption from '../../../components/FilterOption/FilterOption';
import { ProductFilterOptionNode } from '../../../../../../../Interface/ProductFilterOption';
import {
  useProductsFilter,
  FilterState,
} from '../../../../../../Context/ProductsFilterContext';

type SaleFilterItemPropsT = {
  sale: ProductFilterOptionNode;
};

const SaleFilterItem: FC<SaleFilterItemPropsT> = ({ sale }) => {
  const { filters } = useProductsFilter();
  const subSale: ProductFilterOptionNode[] = sale.children
    ? sale.children
        .filter((subItem) => {
          const isActive = filters.sale_percent.includes(
            subItem.value.toString()
          );
          return (subItem.count ?? 0) > 0 || isActive;
        })
        .map(({ name, count, value, filterKey }) => ({
          name,
          value,
          count,
          filterKey: filterKey as keyof FilterState,
        }))
    : [];

  return (
    <div>
      <FilterOption
        key={`${sale.name}-${sale.value}`}
        name={sale.name}
        value={sale.value}
        count={sale.count ?? 0}
        filterKey={sale.filterKey as 'sale_type'}
        node={subSale}
      />
    </div>
  );
};

export default SaleFilterItem;
